import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

let abortControllerFetchInsideAccessories = null;

/**
 * Gọi API lấy danh sách phụ kiện bên trong theo product_type_id
 * endpoint: /modules/v3/inside_accessories/{product_type_id}
 */
export const fetchInsideAccessories = createAsyncThunk(
  'get/modules/v3/inside-accessories',
  async (productTypeId, { dispatch }) => {
    try {
      // Hủy request cũ nếu có
      if (abortControllerFetchInsideAccessories) {
        abortControllerFetchInsideAccessories.abort();
      }
      abortControllerFetchInsideAccessories = new AbortController();

      // const res = await callApi({
      //   endpoint: `modules/v3/inside-accessories?product_type=${productTypeId}`,
      //   method: 'get',
      //   signal: abortControllerFetchInsideAccessories.signal,
      // });

      const res = await callApi({
        endpoint: `modules/v3/inside-accessories`,
        method: 'get',
        params: {
          product_type: productTypeId,
          country_code: process.env.REACT_APP_COUNTRY_CODE,
        },
        signal: abortControllerFetchInsideAccessories.signal,
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      // Gửi action lỗi (nếu muốn bắt thêm ở reducer)
      dispatch({ type: 'fail', payload: error });
      return { error: error.message };
    }
  }
);

/**
 * Gọi API lấy danh sách địa chỉ
 * @param values
 * @param values.accessory_type
 * @param values.accessory_group
 */
export const fetchAccessoryByType = createAsyncThunk(
  'get/modules/v3/accessories_by_type',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'modules/v3/accessories_by_type',
        method: 'get',
        params: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data || [],
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
